import styled from "styled-components";

export const Container = styled.div`
  width: 70%;
  margin: 56px auto;
  animation: fadeIn 500ms ease-in-out;

  @keyframes fadeIn {
    0% {
        opacity: 0;
    }
    25% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
`;